/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Close Full Screen Icon component.
 */
export const CloseFullScreenIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox={`0 0 ${iconSize} ${iconSize}`} fill='none'>
      <path d='M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z' fill={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default CloseFullScreenIcon;
